var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLines2Mdinline = function SvgLines2Mdinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 120,
    viewBox: "0 0 16 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0v120",
    stroke: "#ECE8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8 0v120",
    stroke: "url(#lines2-md_inline_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lines2-md_inline_svg__a",
    x1: 8,
    y1: 25.05,
    x2: 8,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#ECE8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7D64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#ECE8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE8F1"
  })))));
};
export default SvgLines2Mdinline;